import React from "react"
import { Badge } from "../ui/badge"
import {
  SvgAsterisk,
  SvgAmericanExpress,
  SvgDinersClub,
  SvgDiscover,
  SvgJcb,
  SvgMastercard,
  SvgVisa,
} from "../icons/"

interface Props {
  card: any
  setSelectedPaymentMethod: any
  selectedPaymentMethod: any
  setListExpanded: any
  paymentMethods: any
}

const ServiceCardListItem: React.FC<Props> = ({
  card,
  setSelectedPaymentMethod,
  selectedPaymentMethod,
  setListExpanded,
  paymentMethods,
}) => {
  const handleCardClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation()
    setSelectedPaymentMethod(card)
    setListExpanded(false)
  }

  const getCardLogo = () => {
    switch (paymentMethods[0].payment_source.card.brand) {
      case "VISA":
        return <SvgVisa className="mr-[8px]" />
      case "MASTERCARD":
        return <SvgMastercard className="mr-[8px]" />
      case "DISCOVER":
        return <SvgDiscover className="mr-[8px]" />
      case "AMEX":
        return <SvgAmericanExpress className="mr-[8px]" />
      case "JCB":
        return <SvgJcb className="mr-[8px]" />
      case "DINNERSCLUB":
        return <SvgDinersClub className="mr-[8px]" />
      default:
        break
    }
  }

  return (
    <div
      className="flex w-full items-center justify-between"
      onClick={handleCardClick}
    >
      <div className="flex w-[250px] items-center justify-between">
        <div className="flex items-center">
          {getCardLogo()}
          <div className="mr-[16px] flex items-center gap-[4px] xl:gap-[8px]">
            <SvgAsterisk className="h-3 w-3" />
            <SvgAsterisk className="h-3 w-3" />
            <SvgAsterisk className="h-3 w-3" />
            <SvgAsterisk className="h-3 w-3" />
          </div>
          <span className="text-base font-bold">
            {paymentMethods[0].payment_source.card.last_digits}
          </span>
        </div>
      </div>
    </div>
  )
}

export default ServiceCardListItem
